import React from 'react';

import autoBind from 'react-autobind';
import Autocomplete from '@mui/lab/Autocomplete';

// import other components within the same project here
import Localization from "../Localization.jsx"

import {
  TextField,
} from '@mui/material';

class SchoolList extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasLabel: true,
      selectedOption: null,
      options: [],
      schoolList: [],
      schoolID: -1,
      schoolKey: "",
      inputValue: "",
    };
    autoBind(this);

    if (this.props.hasLabel != null) {
      this.state.hasLabel = this.props.hasLabel;
    }

    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.root.refs.API.request("get_school_list", {}, this.getSchoolListOK, this.getSchoolListFailed);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getSchoolListOK(res) {
    if (!this._isMounted) {
      return;
    }
    let tmpList = [];
    const schoolList = (res && res.body && Array.isArray(res.body.result)) ? res.body.result : [];
    for (let i = 0; i < schoolList.length; i++) {
      let schoolRow = schoolList[i];
      tmpList.push({
        school_id: schoolRow['id'],
        school_name: schoolRow['name_eng'] + (schoolRow['name'] != schoolRow['name_eng']? " " + schoolRow['name'] : ""),
        school_key: schoolRow['key'],
      });
    }

    let tmpOptions = tmpList.map(school => ({
      value: school.school_id,
      label: school.school_name,
      key: school.school_key,
    }));

    this.setState({
      schoolList: tmpList,
      options: tmpOptions,
    });
    this.state.schoolList = tmpList;
    this.state.options = tmpOptions;
  }

  getSchoolListFailed(err) {
    console.log("get school list failed");
  }

  onSchoolSelected = (event, selectedOption) => {
    this.setState({ selectedOption });
    if (this.props.onSchoolSelected) {
      this.props.onSchoolSelected(selectedOption);
    }
  }

  onInputChanged = (event, value, reason) => {
    this.setState({ inputValue: value });
    this.state.inputValue = value;
  }

  render() {
    return (
      <Autocomplete 
      inputValue={this.state.inputValue}
      options={this.state.options}
      getOptionLabel={option => option.label}
      renderInput={params => <TextField {...params} 
                                label={this.state.hasLabel? Localization.strings.SCHOOL_LIST : ""} 
                                
                                fullWidth 
                                variant="outlined" 
                                style={{width: '100%', padding: '0px', margin: '0px'}} 
                                
                  />}
      onChange={this.onSchoolSelected}
      onInputChange={this.onInputChanged}
      
    />
    )
  }
}

export default SchoolList;
